import React, { useContext, useEffect, useRef } from "react";
import { ClipLoader } from "react-spinners";
import Breadcrumb from "../Generic/Breadcrumb";
import { getSaluteDetails } from "../Redux/API";
import { AppContext } from "../Redux/ContextProvider";
const Salute = () => {
    const { appState, dispatch } = useContext(AppContext);
    const { salute, saluteLoader } = appState;
    const myRef = useRef(null);
    const allowedSections = [
        "our-25-years-associate",
        "our-30-years-associate",
        "our-20-years-associate",
        "our-15-years-associate",
        "our-10-years-associate",
        "our-5-years-associate",
    ];
    const slugify = (text) => {
        return (text || "")
            .toLowerCase()
            .trim()
            .replace(/[^\w\s-]/g, "")
            .replace(/\s+/g, "-");
    };
    useEffect(() => {
        getSaluteDetails(appState, dispatch)
    }, [])
    return (
        <>
            {
                saluteLoader ?
                    <div className='home-spinner'>
                        <ClipLoader color={"#2A5350"} loading={true} size={60} />
                    </div>
                    :
                    salute && Object.keys(salute).length > 0 &&
                    <>
                        <Breadcrumb
                            pageName={salute.header_contact_section?.title || "salutes"}
                            pageTitle={salute.header_contact_section?.title || "salutes"}
                            id={`#${salute.header_contact_section?.title}`}
                            image={salute.header_contact_section?.banner_image}
                            myRef={myRef}
                        />
                        <div ref={myRef}>
                            <div className="section-sub-title primary3">
                                <h3><span>A SINCERE THANK YOU</span> to ROFDA’s long-term<br />
                                    uninterrupted sponsoring companies!</h3>
                            </div>
                            {
                                salute.salutes_section &&
                                salute.salutes_section.length > 0 &&
                                salute.salutes_section
                                    .filter((section) =>
                                        allowedSections.includes(slugify(section.highlist_title))
                                    )
                                    .map(section => {
                                        const list = section.services_list || [];
                                        const shouldSplit = list.length > 5;
                                        const half = Math.ceil(list.length / 2);
                                        return (
                                            section.services_list?.length > 0 &&
                                            <React.Fragment key={section.highlist_title}>
                                                {
                                                    <div className="portfolio-section solute-section mb-50" id="project">
                                                        <div className="container">
                                                            {/* <div className="section-title2 primary3" data-aos="fade-up">
                                                                <span>{section.main_title}</span>
                                                                <h2>{section.highlist_title}</h2>
                                                                <p className="para">
                                                                    {section.sub_title}
                                                                </p>
                                                            </div> */}
                                                            <div className="solute-main-section" data-aos="fade-up">
                                                                <div className="solute-main-img">
                                                                    <img src={section.image} alt={section.main_title} className="img-fluid" loading="lazy" />
                                                                </div>
                                                                <div className="salutes-items">
                                                                    {(shouldSplit
                                                                        ? [list.slice(0, half), list.slice(half)]
                                                                        : [list]
                                                                    ).map((row, index) => (
                                                                        <div className="salutes-row" key={index}>
                                                                            {row.map((item) => (
                                                                                <div className="solute-img-item" key={item.id}>
                                                                                    <div className="portfolio-content">
                                                                                        <h2>{item.title}</h2>
                                                                                        {/* <span>{section.highlist_title}</span> */}
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                            </React.Fragment>
                                        )
                                    })
                            }
                        </div>
                    </>
            }
        </>
    );
}
export default Salute;